// extracted by css-extract-rspack-plugin
export default {"viewportWidth":"_48758785","xxxSmall":"_34e245d0","xSmall":"_1180c5d0"};